<template>
  <svg
    :class="className"
    :viewBox="viewBox">
    <use :xlink:href="href" />
  </svg>
</template>

<script>
import bemBlockModifiers from "/utils/bem-block-modifiers";
import { isServerSideRendering } from "/ssr-utils/ssr-env";

export default {
  name: "Sprite",
  props: {
    id: { type: String, required: true },
    modifiers: { type: Array, default: () => [] }
  },
  computed: {
    href() {
      return `#${this.id}`;
    },
    className() {
      let className = this.id.split("/");
      className = className.concat(this.modifiers);
      return bemBlockModifiers("sprite-vue", className);
    },
    viewBox() {
      if (isServerSideRendering()) {
        return;
      }
      const el = document.getElementById(this.id);
      if (!el) {
        return;
      }
      return el.getAttribute("viewBox");
    }
  }
};
</script>

<style lang="scss">
.sprite-vue {
  fill: currentColor;

  /* stylelint-disable-next-line selector-nested-pattern */
  &--category,
  &--app {
    width: $basex3;
  }
}

</style>
